<template>
    <div>TODO: studio contatti</div>
</template>

<script>
export default {
    name: "BackendStudioContacts"
};
</script>

<style></style>
